import React, { useState } from 'react';
import { Button } from '@/components/ui/Button';

interface ViewToggleProps {
  view: 'card' | 'table';
  onViewChange: (view: 'card' | 'table') => void;
  enableCard?: boolean;
  enableTable?: boolean;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({
  view,
  onViewChange,
  enableCard = true,
  enableTable = true,
}) => {
  const [cardTooltipVisible, setCardTooltipVisible] = useState(false);
  const [tableTooltipVisible, setTableTooltipVisible] = useState(false);

  return (
    <div className="flex items-center space-x-1 border border-gray-300 rounded-md p-1 bg-white h-10 relative">
      {/* 카드뷰 버튼 */}
      <div className="relative">
        <Button
          variant={view === 'card' ? 'default' : 'ghost'}
          onClick={() => enableCard && onViewChange('card')}
          className={`h-8 px-3 ${!enableCard ? 'opacity-50 cursor-not-allowed' : ''}`}
          onMouseEnter={() => {
            if (!enableCard) {
              setCardTooltipVisible(true);
            }
          }}
          onMouseLeave={() => {
            setCardTooltipVisible(false);
          }}
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
            />
          </svg>
        </Button>
        {/* 카드뷰 비활성화 툴팁 */}
        {cardTooltipVisible && !enableCard && (
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-md whitespace-nowrap z-50 shadow-lg">
            이 테이블은 카드뷰를 지원하지 않습니다
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
              <div className="border-4 border-transparent border-t-gray-900"></div>
            </div>
          </div>
        )}
      </div>

      {/* 테이블뷰 버튼 */}
      <div className="relative">
        <Button
          variant={view === 'table' ? 'default' : 'ghost'}
          onClick={() => enableTable && onViewChange('table')}
          className={`h-8 px-3 ${!enableTable ? 'opacity-50 cursor-not-allowed' : ''}`}
          onMouseEnter={() => {
            if (!enableTable) {
              setTableTooltipVisible(true);
            }
          }}
          onMouseLeave={() => {
            setTableTooltipVisible(false);
          }}
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
        </Button>
        {/* 테이블뷰 비활성화 툴팁 */}
        {tableTooltipVisible && !enableTable && (
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-md whitespace-nowrap z-50 shadow-lg">
            이 테이블은 테이블뷰를 지원하지 않습니다
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
              <div className="border-4 border-transparent border-t-gray-900"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

